import { registerDashboardWidget } from '@/features/dashboards'

/** Module 09's registry is the production caller for persisted `recommendation` widgets. */
export function registerInsightDashboardWidget(): void {
  registerDashboardWidget(
    'recommendation',
    () => import('../components/display/InsightsDashboardWidget.vue'),
  )
}
